import React from 'react';

function H2({
  children,
  dataTest,
}: {
  children?: React.ReactNode;
  dataTest?: string;
}) {
  return (
    <div className="font-semibold text-lg mb-4" data-test={dataTest}>
      {children}
    </div>
  );
}

export default H2;
